<template>
  <el-dialog
      title="新增授权"
      :visible.sync="visible"
      width="450px"
      :before-close="handleClose">
    <el-form :model="form" ref="ruleForm" :rules="rules">
      <el-form-item label="Ukey序列号" label-width="100px" prop="ukeySn">
        <div class="form">
          <el-input v-model="form.ukeySn" placeholder="请输入Ukey序列号" autocomplete="off" disabled></el-input>
          <el-button class="ml10" @click="handleRead">读取</el-button>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleSubmit">确 定</el-button>
  </span>

    <commodity-information
      v-if="commodityVisible"
      :visible.sync="commodityVisible"
      :ukeySn="form.ukeySn"
      :type="type"
      @updateDialog="updateDialog"
    />
  </el-dialog>
</template>

<script>
import { enumDevice } from '@/utils/Ukey'
import CommodityInformation from "@/pages/userCenter/components/commodityInformation.vue";
export default {
  name: "addDialog",
  components: {CommodityInformation},
  props:{
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      form: {
        ukeySn: ''
      },
      rules: {
        ukeySn: [{ required: true, message: "请输入Ukey序列号", trigger: "blur" }],
      },
      commodityVisible: false,
      //  0
      type: 'add'
    };
  },
  methods:{
    handleRead(){
      let ukey = enumDevice()
      if (!ukey){
        this.$message.error('未找到ukey')
      }else {
        this.form.ukeySn = ukey
      }
    },
    handleSubmit(){
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$http.get(this.$api.user.getApplyAuthInfoByUKeySN, {UKeySN: this.form.ukeySn }).then(res => {
            if (res.data.code == 200) {
              if (res.data.data.length > 0){
                //   延期
                this.$confirm('该ukey已授权,授权有效期至：' + res.data.data[0].notAfter + ',是否延期？')
                    .then(()=> {
                      this.type = 'edit'
                      this.commodityVisible = true
                      // this.$http.post(this.$api.user.getApplyAuthProduct).then(res => {
                      //   if (res.data.code == 200) {
                      //     this.$http.post(this.$api.user.createApplyAuthOrder, {buyCount: 1, payType: 'alipay' , productId: res.data.data[0].productId , ukeySN: this.form.ukeySn}).then(res => {
                      //       if (res.data.code == 200) {
                      //
                      //       }
                      //     })
                      //   }
                      // })
                    })
                    .catch(() => {});
              }else {
                this.type = 'add'
                this.commodityVisible = true
              }
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose() {
      this.$confirm('确认关闭？')
          .then(()=> {
            this.updateDialog(false)
          })
          .catch(() => {});
    },

    /* 更新visible */
    updateDialog(value) {
      this.$emit('getApplyESeal');
      this.$emit('update:visible', value);
    }
  }
}
</script>

<style scoped lang="less">
.form{
  display: flex;
}
</style>
